module.exports = __webpack_public_path__ + "static/media/01-09.08c4205d.mp3";